/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Enforcement levels for constraints */
export enum EnforcementLevel {
  Hard,
  Soft,
  Advisory,
  ExceptionBased,
}

export type EnforcementLevelArgs = EnforcementLevel;

export function getEnforcementLevelEncoder(): FixedSizeEncoder<EnforcementLevelArgs> {
  return getEnumEncoder(EnforcementLevel);
}

export function getEnforcementLevelDecoder(): FixedSizeDecoder<EnforcementLevel> {
  return getEnumDecoder(EnforcementLevel);
}

export function getEnforcementLevelCodec(): FixedSizeCodec<
  EnforcementLevelArgs,
  EnforcementLevel
> {
  return combineCodec(
    getEnforcementLevelEncoder(),
    getEnforcementLevelDecoder(),
  );
}
